export interface Avatar {
  id: string;
  name: string;
  images: string[];
  videos?: string[];
  videoSample?: string;
  voiceId: string; 
  voiceSample: string;
  gender?: string;
  age?: number;
}

const BASE_URL = import.meta.env.VITE_CDN_BASE_URL;

export const avatars: Avatar[] = [{
  id: "custom",
  name: "Custom Avatar",
  images: ["https://v3.fal.media/files/rabbit/8NumDvC9j9_2pAUn7NpLi_image.png"],
  voiceId: "",
  voiceSample: ""
},
{
  id: "1",
  name: "Alex",
  voiceId: "o6yjV9HBFcBp8YcCabKr",
  gender: "male",
  age: 35,
  images: [
    `${BASE_URL}/uploads/presets/alex/Alex.png`,
  ],
  videos: [
    `${BASE_URL}/uploads/presets/alex/alex.mp4`,
  ],
  voiceSample: `${BASE_URL}/uploads/presets/alex/Alex.mp3`,
  videoSample: `${BASE_URL}/uploads/presets/alex/alex_sample_2_c.mp4`,
  aspectRatios: ["9:16"]
},
{
  id: "2",
  name: "Arina",
  voiceId: "4lhwLb3aRwwyJmjgxIlu",
  gender: "female",
  age: 25,
  images: [
    `${BASE_URL}/uploads/presets/arina/Arina.png`,
    `${BASE_URL}/uploads/presets/arina/Arina2-kitchen.png`,
    `${BASE_URL}/uploads/presets/arina/Arina3-office.png`
  ],
  videos: [
    `${BASE_URL}/uploads/presets/arina/arina1.mp4`,
    `${BASE_URL}/uploads/presets/arina/arina2.mp4`,
    `${BASE_URL}/uploads/presets/arina/arina3.mp4`
  ],
  voiceSample:
    `${BASE_URL}/uploads/presets/arina/ElevenLabs_2025-04-08T06_14_46_Arina-gg_gen_sp100_s50_sb75_se0_b_m2.mp3`,
  videoSample: `${BASE_URL}/uploads/presets/arina/arina_sample_c.mp4`,
  aspectRatios: ["9:16", "9:16", "9:16"]
},
{
  id: "3",
  name: "Armand",
  voiceId: "u7Xs5vYKtycfLFScP4c9",
  gender: "male",
  age: 30,
  images: [
    `${BASE_URL}/uploads/presets/armand/Armand.png`
  ],
  videos: [
    `${BASE_URL}/uploads/presets/armand/armand.mp4`
  ],
  voiceSample: `${BASE_URL}/uploads/presets/armand/Armand.mp3`,
  videoSample: `${BASE_URL}/uploads/presets/armand/armand_sample_c.mp4`,
  aspectRatios: ["9:16"]
},
{
  id: "4",
  name: "Ashley",
  voiceId: "lyt7iFv9VienZBDyAVZ1",
  gender: "female",
  age: 30,
  images: [
    `${BASE_URL}/uploads/presets/ashley/Ashely-kitchen+baseball+cap.png`,
    `${BASE_URL}/uploads/presets/ashley/Ashley-kitchen.png`
  ],
  videos: [
    `${BASE_URL}/uploads/presets/ashley/ashley1.mp4`,
    `${BASE_URL}/uploads/presets/ashley/ashley2.mp4`
  ],
  voiceSample:
    `${BASE_URL}/uploads/presets/ashley/ElevenLabs_2025-04-24T05_43_19_Ashley-WhiteYoungearly30sAmericanYoutuber_gen_sp100_s50_sb75_se0_b_m2.mp3`,
  videoSample: `${BASE_URL}/uploads/presets/ashley/ashley_sample_c.mp4`,
  aspectRatios: ["9:16", "9:16"]
},
{
  id: "6",
  name: "Destiny",
  voiceId: "BEzOP0CuQnBsiYVCFfxi",
  gender: "female",
  age: 30,
  images: [
    `${BASE_URL}/uploads/presets/destiny/Destiny1.jpeg`,
    `${BASE_URL}/uploads/presets/destiny/Destiny2.jpeg`
  ],
  videos: [
    `${BASE_URL}/uploads/presets/destiny/destiny1.mp4`,
    `${BASE_URL}/uploads/presets/destiny/destiny2.mp4`
  ],
  voiceSample:
    `${BASE_URL}/uploads/presets/destiny/ElevenLabs_2025-04-24T05_46_37_Destiny_gen_sp100_s50_sb75_se0_b_m2.mp3`,
  videoSample: `${BASE_URL}/uploads/presets/destiny/destiny_sample_c.mp4`,
  aspectRatios: ["1:1", "1:1"]
},
{
  id: "7",
  name: "Dylon",
  voiceId: "mvh7VFqCeTREm2QZdzFU",
  gender: "male",
  age: 25,
  images: [
    `${BASE_URL}/uploads/presets/dylon/Dylon.png`
  ],
  videos: [
    `${BASE_URL}/uploads/presets/dylon/dylon.mp4`
  ],
  voiceSample: `${BASE_URL}/uploads/presets/dylon/Dylon.mp3`,
  videoSample: `${BASE_URL}/uploads/presets/dylon/dylon_sample_c.mp4`,
  aspectRatios: ["9:16"]
},
{
  id: "8",
  name: "James",
  gender: "male",
  age: 50,
  voiceId: "DekH8dXNyPaWi2bCez0o",
  images: [
    `${BASE_URL}/uploads/presets/james/James-baseball.png`,
    `${BASE_URL}/uploads/presets/james/James.png`
  ],
  videos: [
    `${BASE_URL}/uploads/presets/james/james1.mp4`,
    `${BASE_URL}/uploads/presets/james/james2.mp4`
  ],
  voiceSample: `${BASE_URL}/uploads/presets/james/James.mp3`,
  videoSample: `${BASE_URL}/uploads/presets/james/james_sample_c.mp4`,
  aspectRatios: ["9:16", "9:16"]
},
{
  id: "9",
  name: "Jessica",
  voiceId: "RHsHqocnOgnl7L5pYmp9",
  gender: "female",
  age: 40,
  images: [
    `${BASE_URL}/uploads/presets/jessica/Jessica-bedroom.png`,
    `${BASE_URL}/uploads/presets/jessica/Jessica-car.png`,
    `${BASE_URL}/uploads/presets/jessica/Jessica-gym.png`,
    `${BASE_URL}/uploads/presets/jessica/Jessica.png`
  ],
  videos:[
    `${BASE_URL}/uploads/presets/jessica/jessica1.mp4`,
    `${BASE_URL}/uploads/presets/jessica/jessica2.mp4`,
    `${BASE_URL}/uploads/presets/jessica/jessica3.mp4`,
    `${BASE_URL}/uploads/presets/jessica/jessica4.mp4`,
  ],
  videoSample: `${BASE_URL}/uploads/presets/jessica/jessica_sample.mp4`,
  voiceSample:
    `${BASE_URL}/uploads/presets/jessica/ElevenLabs_2025-04-24T08_37_39_Jessica_gen_sp95_s55_sb75_se0_b_m2.mp3`,
  aspectRatios: ["9:16", "9:16", "9:16", "9:16"]
},
{
  id: "10",
  name: "Marlon",
  gender: "male",
  age: 30,
  voiceId: "tRSKLu3HcGv2qw0qM3h7",
  images: [
    `${BASE_URL}/uploads/presets/marlon/Marlon.png`
  ],
  videoSample: `${BASE_URL}/uploads/presets/marlon/marlon_sample.mp4`,
  voiceSample: `${BASE_URL}/uploads/presets/marlon/Marlon.mp3`,
  aspectRatios: ["9:16"]
},
{
  id: "11",
  name: "Minh",
  gender: "male",
  age: 35,
  voiceId: "4dczOmwHo0AxRJA5JFc8",
  images: [
    `${BASE_URL}/uploads/presets/minh/minh.png`
  ],
  videoSample: `${BASE_URL}/uploads/presets/minh/minh_sample.mp4`,
  voiceSample: `${BASE_URL}/uploads/presets/minh/Minh.mp3`,
  aspectRatios: ["9:16"]
},
{
  id: "12",
  name: "Nirah",
  voiceId: "8hBFXKdhSIL7wqarz7xX",
  gender: "female",
  age: 35,
  videos: [
    `${BASE_URL}/uploads/presets/nirah/nirah1.mp4`,
    `${BASE_URL}/uploads/presets/nirah/nirah2.mp4`
  ],
  images: [
    `${BASE_URL}/uploads/presets/nirah/Nirah3-bedroom.png`,
    `${BASE_URL}/uploads/presets/nirah/Nirah2-car.png`
  ],
  videoSample: `${BASE_URL}/uploads/presets/nirah/nirah_sample.mp4`,
  voiceSample:
    `${BASE_URL}/uploads/presets/nirah/ElevenLabs_2025-04-24T05_52_11_Nirah-AmericanPersianBG_gen_sp100_s50_sb75_se0_b_m2.mp3`,
  aspectRatios: ["9:16", "16:9"]
},
{
  id: "13",
  name: "Pam",
  gender: "female",
  age: 50,
  images: [
    `${BASE_URL}/uploads/presets/pam/Pam.png`,
    `${BASE_URL}/uploads/presets/pam/Pam2-bedroom.png`,
    `${BASE_URL}/uploads/presets/pam/Pam3-city-park.png`
  ],
  videos: [
    `${BASE_URL}/uploads/presets/pam/pam1.mp4`,
    `${BASE_URL}/uploads/presets/pam/pam2.mp4`,
    `${BASE_URL}/uploads/presets/pam/pam3.mp4`
  ],
  voiceId: "hQbmpQ5VTPIvEvdlMeIJ",
  videoSample: `${BASE_URL}/uploads/presets/pam/pam_sample.mp4`,
  voiceSample:
    `${BASE_URL}/uploads/presets/pam/ElevenLabs_2025-04-24T08_40_58_Pam-middleagedbritish_gen_sp100_s50_sb75_se0_b_m2.mp3`,
  aspectRatios: ["16:9", "9:16", "9:16"]
},
{
  id: "14",
  name: "Ray",
  gender: "male",
  age: 40,
  voiceId: "zI9RJPUNI3RDl51ppw1L",
  images: [
    `${BASE_URL}/uploads/presets/ray/Ray.png`
  ],
  videos: [
    `${BASE_URL}/uploads/presets/ray/ray1.mp4`
  ],
  videoSample: `${BASE_URL}/uploads/presets/ray/ray_sample.mp4`,
  voiceSample: `${BASE_URL}/uploads/presets/ray/Ray.mp3`,
  aspectRatios: ["9:16"]
},
{
  id: "15",
  name: "Amanda",
  gender: "female",
  age: 45,
  voiceId: "zI9RJPUNI3RDl51ppw1L",
  images: [
    `${BASE_URL}/uploads/presets/amanda/Amanda.png`
  ],
  videos: [
    `${BASE_URL}/uploads/presets/amanda/amanda.mp4`
  ],
  videoSample: `${BASE_URL}/uploads/presets/amanda/amanda_sample.mp4`,
  voiceSample: `${BASE_URL}/uploads/presets/amanda/Amanda.mp3`,
  aspectRatios: ["9:16"]
},
{
  id: "16",
  name: "Joo-won",
  gender: "male",
  age: 25,
  voiceId: "zI9RJPUNI3RDl51ppw1L",
  images: [
    `${BASE_URL}/uploads/presets/joo-won/joo-won.png`
  ],
  videos: [
    `${BASE_URL}/uploads/presets/joo-won/joo-won.mp4`
  ],
  videoSample: `${BASE_URL}/uploads/presets/joo-won/joo-won_sample.mp4`,
  voiceSample: `${BASE_URL}/uploads/presets/joo-won/Joo-Won.mp3`,
  aspectRatios: ["9:16"]
},
{
  id: "17",
  name: "Layla",
  voiceId: "zI9RJPUNI3RDl51ppw1L",
  gender: "female",
  age: 40,
  images: [
    `${BASE_URL}/uploads/presets/layla/Layla.png`
  ],
  videos: [
    `${BASE_URL}/uploads/presets/layla/layla.mp4`
  ],
  videoSample: `${BASE_URL}/uploads/presets/layla/layla_sample.mp4`,
  voiceSample: `${BASE_URL}/uploads/presets/layla/Layla.mp3`,
  aspectRatios: ["9:16"]
},
{
  id: "18",
  name: "Quinton",
  age: 50,
  gender: "male",
  voiceId: "zI9RJPUNI3RDl51ppw1L",
  images: [
    `${BASE_URL}/uploads/presets/quinton/Quinton.png`
  ],
  videos: [
    `${BASE_URL}/uploads/presets/quinton/quinton.mp4`
  ],
  videoSample: `${BASE_URL}/uploads/presets/quinton/quinton_sample.mp4`,
  voiceSample: `${BASE_URL}/uploads/presets/quinton/Quinton.mp3`,
  aspectRatios: ["9:16"]
},
{
  id: "19",
  name: "Alexandru Ioan Cuza",
  voiceId: "6sFKzaJr574YWVu4UuJF",
  gender: "male",
  age: 35,
  images: [
    `${BASE_URL}/uploads/presets/cuza/AICuza.png`
  ],
  videos: [
    `${BASE_URL}/uploads/presets/cuza/AICuza.mp4`
  ],
  voiceSample: `${BASE_URL}/uploads/presets/Cuza/AICuza.mp3`,
  videoSample: `${BASE_URL}/uploads/presets/Cuza/AICuza_sample.mp4`,
  aspectRatios: ["1:1"],
  promo: true
},
{
  id: "20",
  name: "Taran Roman",
  voiceId: "NOpBlnGInO9m6vDvFkFC",
  gender: "male",
  age: 25,
  images: [
    `${BASE_URL}/uploads/presets/taran/taranroman.png`,
  ],
  videos: [
    `${BASE_URL}/uploads/presets/taran/TaranRoman.mp4`,
  ],
  voiceSample:
    `${BASE_URL}/uploads/presets/taran/TaranRoman.mp3`,
  videoSample: `${BASE_URL}/uploads/presets/taran/TaranRoman_sample.mp4`,
  aspectRatios: ["1:1"],
  promo: true
},
{
  id: "21",
  name: "Stefan cel Mare",
  voiceId: "uVKHymY7OYMd6OailpG5",
  gender: "male",
  age: 30,
  images: [
    `${BASE_URL}/uploads/presets/stefan/StefanCelMare.png`,
  ],
  videos: [
    `${BASE_URL}/uploads/presets/stefan/StefanCelMareSiSfant.mp4`
  ],
  voiceSample: `${BASE_URL}/uploads/presets/stefan/StefanCelMareVoice-ID-8Es4wFxsDlHBmFWAOWRS.mp3`,
  videoSample: `${BASE_URL}/uploads/presets/stefan/StefanCelMare_sample.mp4`,
  aspectRatios: ["9:16"],
  promo: true
},
{
  id: "22",
  name: "Mihai Viteazul",
  voiceId: "bwCXcoVxWNYMlC6Esa8u",
  gender: "male",
  age: 30,
  images: [
    `${BASE_URL}/uploads/presets/mihai_viteazul/MihaiViteazul.png`,
  ],
  videos: [
    `${BASE_URL}/uploads/presets/mihai_viteazul/MihaiViteazul.mp4`,
  ],
  voiceSample:
    `${BASE_URL}/uploads/presets/mihai_viteazul/MihaiViteazu.mp3`,
  videoSample: `${BASE_URL}/uploads/presets/mihai_viteazul/MihaiViteazu_sample.mp4`,
  aspectRatios: ["9:16"],
  promo: true
},
{
  id: "23",
  name: "Vlad Tepes",
  voiceId: "bwCXcoVxWNYMlC6Esa8u",
  gender: "male",
  age: 30,
  images: [
    `${BASE_URL}/uploads/presets/vlad/VladTepes.png`,
  ],
  videos: [
    `${BASE_URL}/uploads/presets/vlad/VladTepes.mp4`,
  ],
  voiceSample: `${BASE_URL}/uploads/presets/vlad/VladTepesVoice-ID-bwCXcoVxWNYMlC6Esa8u.mp3`,
  videoSample: `${BASE_URL}/uploads/presets/vlad/VladTepes_sample.mp4`,
  aspectRatios: ["9:16"],
  promo: true
},
{
  id: "24",
  name: "Decebal",
  voiceId: "2EiwWnXFnvU5JabPnv8n",
  gender: "male",
  age: 30,
  images: [
    `${BASE_URL}/uploads/presets/decebal/Decebal.png`,
  ],
  videos: [
    `${BASE_URL}/uploads/presets/decebal/Decebal.mp4`,
  ],
  voiceSample: `${BASE_URL}/uploads/presets/decebal/Decebal-ID-2EiwWnXFnvU5JabPnv8n.mp3`,
  videoSample: `${BASE_URL}/uploads/presets/decebal/Decebal_sample.mp4`,
  aspectRatios: ["9:16"],
  promo: true
},
{
  id: "25",
  name: "Mihai Eminescu",
  voiceId: "qEL8pr1hMQPO8lN6PcZ7",
  gender: "male",
  age: 30,
  images: [
    `${BASE_URL}/uploads/presets/eminescu/MihaiEminescu.png`,
  ],
  videos: [
    `${BASE_URL}/uploads/presets/eminescu/MihaiEminescu.mp4`,
  ],
  voiceSample: `${BASE_URL}/uploads/presets/eminescu/MihaiEminescu-ID-qEL8pr1hMQPO8lN6PcZ7.mp3`,
  videoSample: `${BASE_URL}/uploads/presets/eminescu/MihaiEminescu_sample.mp4`,
  aspectRatios: ["9:16"],
  promo: true
}
];
